module.exports = __webpack_public_path__ + "media/images/skill_ic-8c466e6ddf4fc3455939a85d7d903d8a.svg";